module.exports = __webpack_public_path__ + "images/20342d23b96b7f7be053fc628f67ffa5.svg";